import utilityService from './utilityService'
import gridUtils from './gridUtils'
import deepCopyService from './deepCopyService.js'

export default {
    mixins: [utilityService, deepCopyService, gridUtils],
    methods: {
        initializeDrawdownArray(warpThreadsCount, weftThreadsCount) {
            let drawdownArray = new Array(weftThreadsCount)
            for (let weftThreadNumber=0; weftThreadNumber < weftThreadsCount; weftThreadNumber++) {
                drawdownArray[weftThreadNumber] = new Array(warpThreadsCount)
            }
            return drawdownArray
        },

        loadDrawdown(shaftsCount, treadlesCount, warpThreadsCount, weftThreadsCount, affectedWarpThreadNumbers, affectedWeftThreadNumbers, drawdownArray, treadlingArrayIn, threadingArrayIn, tieupArrayIn, reason) {
            // let msg = 'starting loadDrawdown'

            // this.timelog(msg)

            // these next lines remove significant Vue3 observer overhead by removing unneeded reactivity when reading incoming properties
            // this.timelog('loadDrawdown before copy')
            let treadlingArray = this.deepCopy(treadlingArrayIn)
            let threadingArray = this.deepCopy(threadingArrayIn)
            let tieupArray = this.deepCopy(tieupArrayIn)
            // this.timelog('loadDrawdown after copy')

            // if (reason) {
            //     msg += ', ' + reason
            // }
            // this.timelog(msg)

            // console.log('shaftsCount: ' + shaftsCount)
            // console.log('treadlesCount: ' + treadlesCount)
            // console.log('weftThreadsCount: ' + weftThreadsCount)

            let weftThreadNumbersToProcess = affectedWeftThreadNumbers
            let warpThreadNumbersToProcess = affectedWarpThreadNumbers

            // console.log('affectedWarpThreadNumbers: ' + affectedWarpThreadNumbers)
            // console.log('affectedWeftThreadNumbers: ' + affectedWeftThreadNumbers)

            // console.log('drawdownArray: ' + JSON.stringify(drawdownArray))

            // console.log('treadlingArray: ' + JSON.stringify(treadlingArray))
            // console.log('threadingArray: ' + JSON.stringify(threadingArray))
            // console.log('tieupArray: ' + JSON.stringify(tieupArray))

            if (warpThreadNumbersToProcess == null) {
                warpThreadNumbersToProcess = []
                for (let i=0; i < warpThreadsCount; i++) {
                    warpThreadNumbersToProcess.push(i)
                }
            }

            if (weftThreadNumbersToProcess == null) {
                weftThreadNumbersToProcess = []
                for (let i=0; i < weftThreadsCount; i++) {
                    weftThreadNumbersToProcess.push(i)
                }
            }
            // console.log('warpThreadNumbersToProcess: ' + JSON.stringify(warpThreadNumbersToProcess))
            // console.log('weftThreadNumbersToProcess: ' + JSON.stringify(weftThreadNumbersToProcess))

            // this.timelog(JSON.stringify(treadlingArray))

            for (let weftThreadNumber of weftThreadNumbersToProcess) {
                let treadlingRow = weftThreadNumber
                let treadlesForPick = new Array()
                for (let treadleNumber=0; treadleNumber < treadlesCount; treadleNumber++) {
                    let treadlingColumn = treadleNumber
                    // console.log('draftEditService: treadingRow: ' + treadlingRow + ' , treadlingColumn: ' + treadlingColumn)
                    if (treadlingArray[treadlingRow][treadlingColumn]) {
                        treadlesForPick.push(treadleNumber)
                    }
                }

                let shaftsRaisedForPick = new Array()
                for (let treadleNumber of treadlesForPick) {
                    let tieupCol = treadleNumber
                    for (let shaftNumber=0; shaftNumber < shaftsCount; shaftNumber++) {
                        let tieupRow = shaftNumber
                        if (tieupArray[tieupRow][tieupCol]) {
                            shaftsRaisedForPick.push(shaftNumber)
                        }
                    }
                }

                for (let warpThreadNumber of warpThreadNumbersToProcess) {
                    let shaftsForWarpThread = new Array()
                    let threadingColumn = warpThreadNumber
                    for (let shaftNumber=0; shaftNumber < shaftsCount; shaftNumber++) {
                        let threadingRow = shaftNumber
                        if (threadingArray[threadingRow][threadingColumn]) {
                            shaftsForWarpThread.push(shaftNumber)
                        }
                    }
                    let shaftForWarpThread = shaftsForWarpThread[0]
                    let drawdownRow = treadlingRow
                    let drawdownCol = threadingColumn

                    // console.log('drawdownRow: ' + drawdownRow + ' drawdownCol: ' + drawdownCol)
                    // console.log('drawdown: ' + JSON.stringify(this.drawdown))
                    drawdownArray[drawdownRow][drawdownCol] = shaftsRaisedForPick.includes(shaftForWarpThread)
                }
            }

            // msg = 'assigning result in loadDrawdown'
            // if (reason) {
            //     msg += ', ' + reason
            // }

            // drawdownArrayIn = drawdownArray

            // msg = 'finished loadDrawdown'
            // if (reason) {
            //     msg += ', ' + reason
            // }

            // this.timelog(msg)
            // this.drawdownRenderingKey = this.uuidv4()
        },

        renderDrawdown(canvas, canvasWidth, canvasHeight, drawdownDataArray, warpThreadsArray, weftThreadsArray, drawWarpThreads, clearCanvas, showReverseSide, drawLeftToRight, drawTopToBottom) {
            // this.timelog('starting renderDrawdown')
            if (clearCanvas) {
                canvas.fillStyle = 'rgb(0, 0, 0)'
                canvas.fillRect(0, 0, canvasWidth, canvasHeight)
            }

            // put these here instead of in the deep loop for efficiency
            let cellX = 0
            let cellY = 0
            let displayRowNum = 0
            let displayColNum = 0
            let warpThreadIsShowing = false
            let threadColor = {}
            let cellWidth = 0
            let cellHeight = 0
            let displayY = 0
            let displayX = 0
            let rowIndex = 0
            let colIndex = 0
            let displayUnderDataRowIndex = 0
            let displayRightDataColIndex = 0
            let warpThreadIsShowingUnder = 0
            let weftThreadIsShowingRight = 0

            // Vue this. resolution is apparently quite expensive, so do that once outside the deep loop for efficiency
            let cps = this.cellPixelSize
            let bpt = this.borderThicknessPixels
            let columnsCount = this.columnsCount
            let rowsCount = this.rowsCount
            let showDividingLines = this.showDividingLines
            let getDisplayGridIndex = this.getDisplayGridIndex

            for (rowIndex=0; ((rowIndex < rowsCount) && (rowIndex < weftThreadsArray.length)); rowIndex++) {
                displayRowNum = getDisplayGridIndex(rowIndex, !drawTopToBottom, rowsCount)
                cellY = displayRowNum * (cps + bpt) + bpt
                for (colIndex=0; ((colIndex < columnsCount) && (colIndex < warpThreadsArray.length)); colIndex++) {
                    displayColNum = getDisplayGridIndex(colIndex, !drawLeftToRight, columnsCount)
                    cellX = displayColNum * (cps + bpt) + bpt
                    warpThreadIsShowing = showReverseSide ? !drawdownDataArray[rowIndex][colIndex] : drawdownDataArray[rowIndex][colIndex]
                    threadColor = warpThreadIsShowing ? warpThreadsArray[colIndex] : weftThreadsArray[rowIndex]
                    cellWidth = cps
                    cellHeight = cps
                    displayY = cellY
                    displayX = cellX

                    if (showDividingLines) {
                        if (warpThreadIsShowing) {
                            if (displayRowNum < rowsCount-1) {
                                displayUnderDataRowIndex = getDisplayGridIndex(displayRowNum+1, !drawTopToBottom, rowsCount)
                                warpThreadIsShowingUnder = showReverseSide ? !drawdownDataArray[displayUnderDataRowIndex][colIndex] : drawdownDataArray[displayUnderDataRowIndex][colIndex]
                                if (warpThreadIsShowingUnder) {
                                    cellHeight += bpt
                                }
                            }
                        }
                        else {
                            if (displayColNum < columnsCount-1) {
                                displayRightDataColIndex = getDisplayGridIndex(displayColNum+1, !drawLeftToRight, columnsCount)
                                weftThreadIsShowingRight = showReverseSide ? (drawdownDataArray[rowIndex][displayRightDataColIndex]) : !(drawdownDataArray[rowIndex][displayRightDataColIndex])
                                if (weftThreadIsShowingRight) {
                                    cellWidth += bpt
                                }
                            }
                        }
                    }
                    else {
                        displayX -= bpt
                        displayY -= bpt
                        cellWidth += (bpt * 2)
                        cellHeight += (bpt * 2)
                    }
                    if (threadColor) {
                        if (!warpThreadIsShowing || drawWarpThreads) { // for overshot view where warp threads are never drawn
                            canvas.fillStyle='rgb(' + threadColor.R + ',' + threadColor.G + ',' + threadColor.B + ')'
                            canvas.fillRect(displayX, displayY, cellWidth, cellHeight)
                        }
                    }
                    // if (rowIndex < 4 && colIndex < 4) {
                    //     // console.log('rowIndex: ' + rowIndex + ', colIndex: ' + colIndex + ' threadColor: ' + JSON.stringify(threadColor))
                    // }
                }
            }
            // console.log('warpThreads: ' + JSON.stringify(this.warpThreads))
            // this.timelog('finshed renderDrawdown')
        }
    }
}
